import * as amplitude from '@amplitude/analytics-browser';

module.exports = amplitude;
